export const PRODUCT_CATEGORIES = [
  'Livres & Bibles',
  'Articles religieux (chapelets, croix, etc.)',
  'Mode chrétienne',
  'Bien-être',
  'Artisanat',
  'Papeterie (cahiers, carnets, supports)',
  'Autre',
];
